import { render, staticRenderFns } from "./ObjectTemplatesAttributes.vue?vue&type=template&id=12acd282&"
import script from "./ObjectTemplatesAttributes.vue?vue&type=script&lang=js&"
export * from "./ObjectTemplatesAttributes.vue?vue&type=script&lang=js&"
import style0 from "./ObjectTemplatesAttributes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports